import React from 'react';
import { ChevronRight, Users } from 'lucide-react';

const PanelItem = ({ name, memberCount, badgeCount, isActive = false }) => {
  return (
    <button
      id={`panel-${name.toLowerCase().replace(/\s+/g, '-')}`}
      className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-left
                   transition-all duration-200 group
                   ${isActive 
                     ? 'bg-accent-indigo/5 border border-accent-indigo/20' 
                     : 'hover:bg-gray-50 border border-transparent'}`}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className={`text-sm font-medium truncate ${isActive ? 'text-accent-indigo' : 'text-text-black'}`}>
            {name}
          </span>
          {badgeCount > 0 && (
            <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-[11px] font-semibold 
                             text-white bg-accent-indigo rounded-full">
              {badgeCount}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1 mt-0.5">
          <Users size={12} className="text-light-gray" />
          <span className="text-xs text-light-gray">{memberCount?.toLocaleString()} members</span>
        </div>
      </div>
      <ChevronRight 
        size={16} 
        className={`flex-shrink-0 transition-colors duration-200
                    ${isActive ? 'text-accent-indigo' : 'text-light-gray group-hover:text-text-black'}`} 
      />
    </button>
  );
};

export default PanelItem;